(() => {
  let GetCartJson = async () => {
    return await fetch('/cart.js').then((res) => res.json());
  }

  let ShippingProgressBar = () => {
    document.querySelectorAll('.shipping-progress-bar').forEach(($bar) => {
      var progressbar = new ProgressBar.Line($bar, {
        strokeWidth: 3,
        easing: 'easeInOut',
        duration: 700,
        color: $bar.dataset.progressbarColor,
        trailColor: $bar.dataset.progressbarTrailColor,
        trailWidth: $bar.dataset.progressbarWidth,
        svgStyle: {width: '100%', height: '100%'}
      });

      document.addEventListener('shipping:progress:update', (e) => {
        let cartTotal = parseFloat($bar.dataset.cartTotal);
        let minTotal = parseFloat($bar.dataset.minTotal);
        let percent = cartTotal / minTotal;
        if (percent > 1) {
          percent = 1;
        }
        progressbar.animate(percent);

        let $message = $bar.closest('.shipping-progress-wrap').querySelector('.shipping-progress-message');
        let formatted_amount = theme.Currency.formatMoney((minTotal - cartTotal));
        let message_complete = $bar.dataset.messageComplete;
        let message_incomplete = $bar.dataset.messageIncomplete.replaceAll('{$amount}', formatted_amount);
        
        let message = (cartTotal >= minTotal) ? message_complete : message_incomplete;
        
        const cartForm = document.querySelector('form[action="/cart"]');
        if (cartTotal >= minTotal){
          cartForm.classList.add('threshold-met');
        }
        else {
          cartForm.classList.remove('threshold-met');
        }
        $message.innerHTML = message;
      });

      document.dispatchEvent(new CustomEvent('shipping:progress:update'));
    });    
  }

  const DOMReady = () => {
    ShippingProgressBar();
    // when cart updated, trigger progress bar update
    document.addEventListener('cart:updated', async (e) => {
      let cartJson = await GetCartJson();
      document.querySelectorAll('.shipping-progress-bar').forEach(($bar) => {
        $bar.dataset.cartTotal = cartJson.total_price;
      });

      document.dispatchEvent(new CustomEvent('shipping:progress:update'));
    });

    // when item added to cart
    document.addEventListener('ajaxProduct:added', (e) => {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  };

  document.addEventListener('DOMContentLoaded', DOMReady);
})();